// extracted by mini-css-extract-plugin
export default {"banner":"Asia_banner__FASq4","bant":"Asia_bant__MXB+Y"};